import * as React from 'react'

function SvgPw(props) {
	return (
		<svg viewBox="0 0 800 500" width="1em" height="1em" {...props}>
			<path fill="#4AADD6" d="M0 0h800v500H0z" />
			<circle fill="#FFDE00" cx={350} cy={250} r={150} />
		</svg>
	)
}

export default SvgPw
